"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns true if given date was the day after
 * the other given date.
 *
 * @param {Date} date The date to check.
 * @param {Date} previousDate Date to check against.
 *
 * @returns {Boolean}
 */
function isDayAfter(date, previousDate) {
    return (date.getDate() === previousDate.getDate() + 1 &&
        date.getMonth() === previousDate.getMonth() &&
        date.getFullYear() === previousDate.getFullYear());
}
exports.default = isDayAfter;
//# sourceMappingURL=isDayAfter.js.map